var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_video",
    "data-name": "vuesax/bulk/video",
    transform: "translate(-108 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.75,0h-6C1.33,0,0,1.33,0,4.75v8A4.415,4.415,0,0,0,4.75,17.5h6c3.42,0,4.75-1.33,4.75-4.75v-8C15.5,1.33,14.17,0,10.75,0Z",
    transform: "translate(110.25 255.25)",
    fill: "#de7f03",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M3.76,1.88A1.88,1.88,0,1,1,1.88,0,1.88,1.88,0,0,1,3.76,1.88Z",
    transform: "translate(117.62 259.62)",
    fill: "#de7f03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M3.92.2a2.27,2.27,0,0,0-2.44.37L0,1.613c.01.14.02.27.02.42v8c0,.15-.02.28-.02.42l1.48,1.04a2.752,2.752,0,0,0,1.59.58,1.83,1.83,0,0,0,.85-.2,2.257,2.257,0,0,0,1.1-2.21V2.413A2.257,2.257,0,0,0,3.92.2Z",
    transform: "translate(125.73 257.967)",
    fill: "#de7f03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(108 252)",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.df32175055a85befcf1cf029df309a93.svg";
export { ForwardRef as ReactComponent };